$(".scent-item").click(function(){
  $(".scent-item").removeClass('active');
  $(this).addClass('active');
  var title = $(this).data('title');
  var image = $(this).data('image');
  var description = $(this).data('description');
  $('.scent-title').text(title);
  $('.scent-image img').attr('src',image);
  $('.scent-description').text(description);
  var handle = $(this).data('handle');
  $(".list-variants option[data-handle='" + handle +"']").attr("selected","selected");
  $('.list-variants').each(function(i, obj) {
    var variant_id = $(this).find("option[data-handle='" + handle +"']").val();
    var product_handle =  $(this).attr('id').replace('variants-','');
    if(variant_id != undefined){
      $(this).next().find('input[name="id"]').val(variant_id);
      $('.product-item.product-handle-'+product_handle).show().addClass('active');
      var price = $(this).find("option[data-handle='" + handle +"']").data('price');
      var priceSub = parseInt(price) * 0.9; 
      console.log("Product: "+product_handle+" | Price: "+price + " - Price Sub:"+priceSub);
      $('.product-info-top.product-handle-'+product_handle).find('.product-price').text(Shopify.formatMoney(price, $('body').data('money-format')));
      $('.product-info-top.product-handle-'+product_handle).find('.recharge-subscription-widget .onetime-radio .rc-radio__price').text(Shopify.formatMoney(price, $('body').data('money-format')));
      $('.product-info-top.product-handle-'+product_handle).find('.recharge-subscription-widget .subscription-radio .rc-radio__price').text(Shopify.formatMoney(priceSub, $('body').data('money-format')));
    }else{
      $('.product-item.product-handle-'+product_handle).hide().removeClass('active');
    }
  });
  $(this).closest('body').find('.js-pickup-drawer #pickup-availability-heading').next().find('span').text(title);
   window.location.hash = handle;
    //if( handle == 'citronella-lemongrass' || handle == 'fragrance-free' || handle == 'wild-watermelon' || handle == 'dirty-birch'){
       setTimeout(function () {
          $(".product-item.active:first").click();
       }, 300);
    //}
});

$(".product-item").click(function(){
  $(".product-item .product-item-image").removeClass('active');
  $(this).find('.product-item-image').addClass('active');
  var product_handle = $(this).data('handle');
  $('.scent-product-slide').hide().removeClass('active');
  $('.scent-product-slide.product-handle-'+product_handle).show().addClass('active');
  $('.product-info-top').hide().removeClass('active');
  $('.product-info-top.product-handle-'+product_handle).show().addClass('active');
  $('.product-info-bottom').hide().removeClass('active');
  $('.product-info-bottom.product-handle-'+product_handle).show().addClass('active');
  var product_title = $(this).find('.product-item-title').text();
  $(this).closest('body').find('.js-pickup-drawer #pickup-availability-heading').text(product_title);
});

$(".rc-radio").click(function(){
  $(this).parent().find('.rc-radio').removeClass('rc-radio--active');
  $(this).addClass('rc-radio--active');
 
  var valueChecked = $(this).find('input[type="radio"]:checked').val();
  if(valueChecked == 'onetime'){
    $(this).closest('.recharge-subscription-widget').next().next().find('input[name="selling_plan"]').val('');
  }else{
    var selling_plan_id = $(this).next().find('.rc-selling-plans-dropdown__select').val();
    $(this).closest('.recharge-subscription-widget').next().next().find('input[name="selling_plan"]').val(selling_plan_id);
  }
  var price = $(this).find('.rc-radio__price').text();
  $(this).closest('.product-info-top').find('.product-price').text(price);
});

$('select.rc-selling-plans-dropdown__select').on('change', function() {
  $(this).closest('.recharge-subscription-widget').next().next().find('input[name="selling_plan"]').val(this.value);
});


$(document).ready(function() {

  var currentURL = $(location).attr("href");
  $(".scent-list .scent-item").each(function(index, item) {
    var handle = $(this).data("handle");
    if(currentURL.indexOf(handle) != -1){
      setTimeout(function () {
          $('.scent-list .scent-item[data-handle="'+handle+'"]').trigger('click');
          var indexItem = $('.scent-list .scent-item[data-handle="'+handle+'"]').attr('data-slick-index');
          $('.scent-list').slick('slickGoTo', indexItem);
      }, 500);
    }
  });

  var scent_default = $(".scent-list").data('scent-default');
  console.log('scent_default = '+scent_default);
  if(scent_default != undefined){
    setTimeout(function () {
      $('.scent-list .scent-item[data-handle="'+scent_default+'"]').trigger('click');
      var indexItem = $('.scent-list .scent-item[data-handle="'+scent_default+'"]').attr('data-slick-index');
      $('.scent-list').slick('slickGoTo', indexItem);
    }, 500);
  }

  $(".scent-product-slide").each(function(index, item) {
    if(index > 0){
      $(this).css('visibility', 'visible').hide();
    }
  });
  
  $(".scent-list .scent-item").css('display','block'); 
  $('.scent-list').slick({
    slidesToShow: 10,
    slidesToScroll: 8,
    arrows: true,
    variableWidth: true,
    infinite: false,
    draggable: true,
    nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
    prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 6
        }
      },
       {
        breakpoint: 991,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 4
        }
      },
     {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
});  

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};




